<div #videoWrapper [class.hidden-controls]="config?.mediaSource?.subtype !== MEDIA_SUBTYPE.MAIN && !startedMain" [class.no-play]="!playButton">
    <video style="width: 100%; height: 100%;" #target class="video-js" oncontextmenu="return false;" webkit-playsinline playsinline crossorigin="anonymous"></video>
</div>
